/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as TutorialRouteImport } from './routes/tutorial'
import { Route as StaffServerRouteImport } from './routes/staff-server'
import { Route as StaffPrinterRouteImport } from './routes/staff-printer'
import { Route as StaffLoginRouteImport } from './routes/staff-login'
import { Route as StaffKitchenRouteImport } from './routes/staff-kitchen'
import { Route as StaffRouteImport } from './routes/staff'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AssistantSettingsRouteImport } from './routes/assistant-settings'
import { Route as AssistantLoginRouteImport } from './routes/assistant-login'
import { Route as AssistantDashboardRouteImport } from './routes/assistant-dashboard'
import { Route as AdminCancellationsRouteImport } from './routes/admin-cancellations'
import { Route as AccountingRouteImport } from './routes/accounting'
import { Route as IndexRouteImport } from './routes/index'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const TutorialRoute = TutorialRouteImport.update({
  id: '/tutorial',
  path: '/tutorial',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffServerRoute = StaffServerRouteImport.update({
  id: '/staff-server',
  path: '/staff-server',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffPrinterRoute = StaffPrinterRouteImport.update({
  id: '/staff-printer',
  path: '/staff-printer',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffLoginRoute = StaffLoginRouteImport.update({
  id: '/staff-login',
  path: '/staff-login',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffKitchenRoute = StaffKitchenRouteImport.update({
  id: '/staff-kitchen',
  path: '/staff-kitchen',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffRoute = StaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuRoute = MenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantSettingsRoute = AssistantSettingsRouteImport.update({
  id: '/assistant-settings',
  path: '/assistant-settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantLoginRoute = AssistantLoginRouteImport.update({
  id: '/assistant-login',
  path: '/assistant-login',
  getParentRoute: () => rootRouteImport,
} as any)
const AssistantDashboardRoute = AssistantDashboardRouteImport.update({
  id: '/assistant-dashboard',
  path: '/assistant-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCancellationsRoute = AdminCancellationsRouteImport.update({
  id: '/admin-cancellations',
  path: '/admin-cancellations',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountingRoute = AccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/admin-cancellations': typeof AdminCancellationsRoute
  '/assistant-dashboard': typeof AssistantDashboardRoute
  '/assistant-login': typeof AssistantLoginRoute
  '/assistant-settings': typeof AssistantSettingsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/menu': typeof MenuRoute
  '/set-password': typeof SetPasswordRoute
  '/settings': typeof SettingsRoute
  '/staff': typeof StaffRoute
  '/staff-kitchen': typeof StaffKitchenRoute
  '/staff-login': typeof StaffLoginRoute
  '/staff-printer': typeof StaffPrinterRoute
  '/staff-server': typeof StaffServerRoute
  '/tutorial': typeof TutorialRoute
  '/welcome': typeof WelcomeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/admin-cancellations': typeof AdminCancellationsRoute
  '/assistant-dashboard': typeof AssistantDashboardRoute
  '/assistant-login': typeof AssistantLoginRoute
  '/assistant-settings': typeof AssistantSettingsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/menu': typeof MenuRoute
  '/set-password': typeof SetPasswordRoute
  '/settings': typeof SettingsRoute
  '/staff': typeof StaffRoute
  '/staff-kitchen': typeof StaffKitchenRoute
  '/staff-login': typeof StaffLoginRoute
  '/staff-printer': typeof StaffPrinterRoute
  '/staff-server': typeof StaffServerRoute
  '/tutorial': typeof TutorialRoute
  '/welcome': typeof WelcomeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounting': typeof AccountingRoute
  '/admin-cancellations': typeof AdminCancellationsRoute
  '/assistant-dashboard': typeof AssistantDashboardRoute
  '/assistant-login': typeof AssistantLoginRoute
  '/assistant-settings': typeof AssistantSettingsRoute
  '/dashboard': typeof DashboardRoute
  '/inventory': typeof InventoryRoute
  '/menu': typeof MenuRoute
  '/set-password': typeof SetPasswordRoute
  '/settings': typeof SettingsRoute
  '/staff': typeof StaffRoute
  '/staff-kitchen': typeof StaffKitchenRoute
  '/staff-login': typeof StaffLoginRoute
  '/staff-printer': typeof StaffPrinterRoute
  '/staff-server': typeof StaffServerRoute
  '/tutorial': typeof TutorialRoute
  '/welcome': typeof WelcomeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounting'
    | '/admin-cancellations'
    | '/assistant-dashboard'
    | '/assistant-login'
    | '/assistant-settings'
    | '/dashboard'
    | '/inventory'
    | '/menu'
    | '/set-password'
    | '/settings'
    | '/staff'
    | '/staff-kitchen'
    | '/staff-login'
    | '/staff-printer'
    | '/staff-server'
    | '/tutorial'
    | '/welcome'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounting'
    | '/admin-cancellations'
    | '/assistant-dashboard'
    | '/assistant-login'
    | '/assistant-settings'
    | '/dashboard'
    | '/inventory'
    | '/menu'
    | '/set-password'
    | '/settings'
    | '/staff'
    | '/staff-kitchen'
    | '/staff-login'
    | '/staff-printer'
    | '/staff-server'
    | '/tutorial'
    | '/welcome'
  id:
    | '__root__'
    | '/'
    | '/accounting'
    | '/admin-cancellations'
    | '/assistant-dashboard'
    | '/assistant-login'
    | '/assistant-settings'
    | '/dashboard'
    | '/inventory'
    | '/menu'
    | '/set-password'
    | '/settings'
    | '/staff'
    | '/staff-kitchen'
    | '/staff-login'
    | '/staff-printer'
    | '/staff-server'
    | '/tutorial'
    | '/welcome'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountingRoute: typeof AccountingRoute
  AdminCancellationsRoute: typeof AdminCancellationsRoute
  AssistantDashboardRoute: typeof AssistantDashboardRoute
  AssistantLoginRoute: typeof AssistantLoginRoute
  AssistantSettingsRoute: typeof AssistantSettingsRoute
  DashboardRoute: typeof DashboardRoute
  InventoryRoute: typeof InventoryRoute
  MenuRoute: typeof MenuRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  StaffRoute: typeof StaffRoute
  StaffKitchenRoute: typeof StaffKitchenRoute
  StaffLoginRoute: typeof StaffLoginRoute
  StaffPrinterRoute: typeof StaffPrinterRoute
  StaffServerRoute: typeof StaffServerRoute
  TutorialRoute: typeof TutorialRoute
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tutorial': {
      id: '/tutorial'
      path: '/tutorial'
      fullPath: '/tutorial'
      preLoaderRoute: typeof TutorialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff-server': {
      id: '/staff-server'
      path: '/staff-server'
      fullPath: '/staff-server'
      preLoaderRoute: typeof StaffServerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff-printer': {
      id: '/staff-printer'
      path: '/staff-printer'
      fullPath: '/staff-printer'
      preLoaderRoute: typeof StaffPrinterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff-login': {
      id: '/staff-login'
      path: '/staff-login'
      fullPath: '/staff-login'
      preLoaderRoute: typeof StaffLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff-kitchen': {
      id: '/staff-kitchen'
      path: '/staff-kitchen'
      fullPath: '/staff-kitchen'
      preLoaderRoute: typeof StaffKitchenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff': {
      id: '/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu': {
      id: '/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof MenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant-settings': {
      id: '/assistant-settings'
      path: '/assistant-settings'
      fullPath: '/assistant-settings'
      preLoaderRoute: typeof AssistantSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant-login': {
      id: '/assistant-login'
      path: '/assistant-login'
      fullPath: '/assistant-login'
      preLoaderRoute: typeof AssistantLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assistant-dashboard': {
      id: '/assistant-dashboard'
      path: '/assistant-dashboard'
      fullPath: '/assistant-dashboard'
      preLoaderRoute: typeof AssistantDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-cancellations': {
      id: '/admin-cancellations'
      path: '/admin-cancellations'
      fullPath: '/admin-cancellations'
      preLoaderRoute: typeof AdminCancellationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounting': {
      id: '/accounting'
      path: '/accounting'
      fullPath: '/accounting'
      preLoaderRoute: typeof AccountingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountingRoute: AccountingRoute,
  AdminCancellationsRoute: AdminCancellationsRoute,
  AssistantDashboardRoute: AssistantDashboardRoute,
  AssistantLoginRoute: AssistantLoginRoute,
  AssistantSettingsRoute: AssistantSettingsRoute,
  DashboardRoute: DashboardRoute,
  InventoryRoute: InventoryRoute,
  MenuRoute: MenuRoute,
  SetPasswordRoute: SetPasswordRoute,
  SettingsRoute: SettingsRoute,
  StaffRoute: StaffRoute,
  StaffKitchenRoute: StaffKitchenRoute,
  StaffLoginRoute: StaffLoginRoute,
  StaffPrinterRoute: StaffPrinterRoute,
  StaffServerRoute: StaffServerRoute,
  TutorialRoute: TutorialRoute,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
